module.exports = __webpack_public_path__ + "logo_53-bb2b6c02b058d56229b45ffb56b59888.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_53.png
// module id = 1140
// module chunks = 0 1